import { http, getDeviceId } from "@/lib/api";
import { attributionProps } from "@/lib/attribution";

// Privacy-first product telemetry. Fire-and-forget; never sends free text.
// Acquisition attribution (source/campaign/content/lens/entry) is auto-merged.
// The backend enforces an event allow-list and a prop key whitelist.
export function track(name, props = {}) {
  try {
    http.post("/events", {
      name,
      device_id: getDeviceId(),
      props: { ...attributionProps(), ...props },
    }).catch(() => {});
  } catch (e) { /* never block the UI on analytics */ }
}
